<template>
  <div class="sourceBusyness">
    <div class="module-header">繁忙度配置</div>

    <a-collapse
      class="custom-collapse"
      v-model="activeKey"
      :bordered="false"
    >
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel header="操作系统" key="os">
        <a-space class="main-space" v-if="!itemLoading">
          <div class="label">指标配置：</div>
          <div style="width: 100%; margin-top: -10px">
            <!-- 已添加指标 -->
            <form-item
              class="item"
              v-for="(item) in indicatorList"
              :key="item.id"
              :item-data="item"
              :item-list="itemList"
              @refresh="fetchIndicatorList()"
            >
            </form-item>

            <!-- 待添加指标 -->
            <form-item
              class="item"
              v-for="(item, index) in addList"
              :key="`add${index}`"
              :item-data="item"
              :item-list="itemList"
              :is-create="true"
              @cancelAdd="addList.splice(index, 1)"
              @refresh="fetchIndicatorList()"
            >
            </form-item>

            <a-button
              type="dashed"
              icon="plus"
              @click="handleAdd"
              style="width: 100%; margin-top: 18px"
            >
              添加指标
            </a-button>
          </div>
        </a-space>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import {
  getSourceBusynessItemList,
  getSourceBusynessIndicatorList
} from '@/api/source-busyness.js'
import FormItem from './modules/FormItem.vue'

export default {
  name: 'SourceBusyness',
  components: {
    FormItem
  },
  data () {
    return {
      activeKey: 'os',
      addList: [], // 待添加指标集合
      indicatorList: [],
      itemLoading: false,
      itemList: []
    }
  },
  created () {
    this.fetchItemList()
    this.fetchIndicatorList()
  },
  methods: {
    fetchIndicatorList () {
      getSourceBusynessIndicatorList().then(res => {
        const data = res.data
        this.indicatorList = data ? data.data : []
      })
    },
    fetchItemList () {
      this.itemLoading = true
      getSourceBusynessItemList().then(res => {
        const data = res.data
        this.itemList = data ? data.data : []
      }).finally(() => {
        this.itemLoading = false
      })
    },
    handleAdd () {
      this.addList.push({
        key: '',
        method: '',
        value_range: [30, 60]
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sourceBusyness {
  position: relative;
  border-radius: 8px;
  background: #fff;
  min-height: calc(100vh - 158px);
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
  padding: 18px;

  .custom-collapse {
    background: #fff;
    margin: 24px 64px 10px 58px;
    :deep(.ant-collapse-item) {
      border-bottom: none;
      margin-bottom: 12px;
      .ant-collapse-header {
        padding: 8px 16px !important;
        border-radius: 8px;
        background: #e8f3ff;
        .ant-collapse-arrow {
          right: 16px !important;
        }
      }
      .ant-collapse-content {
        background-color: #fff;
        padding: 12px 16px;

        .main-space {
          width: 100%;
          align-items: flex-start;
          & > .ant-space-item:last-of-type {
            flex: 1;
          }
          .label {
            width: 80px;
            margin-top: 6px;
          }
          .item {
            margin-top: -4px;
          }
        }
      }
    }
  }
}
</style>
